<template>
  <img src="@/assets/img/Icons/gallery/primary.svg" />
</template>

<script>
export default {}
</script>

<style></style>
